"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LIVE_AGENT_LOADED = exports.CHAT_BUTTON_ID = exports.AVAILABILITY_CHANGE = void 0;
var _events = _interopRequireDefault(require("events"));
var _timeouts = require("../constants/timeouts");
var _loadScript = _interopRequireDefault(require("../utils/loadScript"));
const LIVE_AGENT_LOADED = exports.LIVE_AGENT_LOADED = 'LiveAgentLoaded';
const CHAT_BUTTON_ID = exports.CHAT_BUTTON_ID = 'liveagent_button_online';
const AVAILABILITY_CHANGE = exports.AVAILABILITY_CHANGE = 'LiveChatAvailabilityChange';
/**
 * LiveAgent module
 */
class LiveChat extends _events.default {
  /**
   * @param {Object} settings the settings
   * @returns {void} nothing
   */
  init(scriptUrl, settings) {
    this.isAvailable = false;
    this.settings = {
      ...settings
    };
    (0, _loadScript.default)(scriptUrl, () => this.initializeLiveAgent(), _timeouts.timeouts.SECONDARY_SCRIPT_DELAY);
  }

  /**
   * @param {Object} settings the settings
   * @returns {void} nothing
   */
  initializeLiveAgent() {
    const {
      liveagent
    } = window;
    liveagent.init(this.settings.liveAgentUrl, this.settings.deploymentId, this.settings.orgId);
    liveagent.showWhenOnline(this.settings.chatId, document.getElementById(CHAT_BUTTON_ID));
    liveagent.addButtonEventHandler(this.settings.chatId, evt => {
      switch (evt) {
        case liveagent.BUTTON_EVENT.BUTTON_AVAILABLE:
          this.isAvailable = true;
          this.emit(AVAILABILITY_CHANGE, true);
          break;
        case liveagent.BUTTON_EVENT.BUTTON_UNAVAILABLE:
          this.isAvailable = false;
          this.emit(AVAILABILITY_CHANGE, false);
          break;
        default:
          break;
      }
    });
  }

  /**
   * @returns {Boolean} if live agent is available
   */
  get IsAvailable() {
    return this.isAvailable;
  }

  /**
   * @returns {Void} nothing
   */
  startChat() {
    window.liveagent.startChat(this.settings.chatId);
  }
}
exports.default = LiveChat;